"use strict";

exports.__esModule = true;
exports["default"] = CircleExclamation;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CircleExclamation(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M256.053 1C115.451 1 1 115.337 1 255.929 1 396.591 115.451 511 256.053 511S511 396.591 511 255.929C511 115.337 396.654 1 256.053 1zm-15.832 92.689h31.593c23.268 0 40.7 16.347 38.708 36.305l-14.053 126.147c-1.992 19.958-20.172 36.287-40.416 36.287-20.243 0-38.423-16.329-40.451-36.287l-14.053-126.147c-2.028-19.958 15.404-36.305 38.672-36.305zm15.76 344.454c-31.414 0-56.781-23.443-56.781-54.928 0-30.879 25.367-54.358 56.781-54.358 30.774 0 56.142 23.479 56.142 54.358 0 31.484-25.367 54.928-56.142 54.928z"
  }));
}